import { Dropdown, DropdownProps } from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import moment from "moment";
import React, { useMemo } from "react";

import { copyTimeToDate } from "../../utils/timeUtils";

type Props = {
  field: FieldDescriptor<Date>;
  minuteIntervals?: number;
} & DropdownProps;

export const TimeField: React.FC<Props> = ({ field, minuteIntervals, ...dropdownProps }) => {
  const { items, nextAvailable } = useMemo(() => {
    let dt = new Date(1970, 0, 1);
    let nd: Date | undefined = undefined;
    const rc: { header: string; value: Date }[] = [];
    const step = minuteIntervals || 30;
    const currentHours = new Date().getHours();
    const currentMinutes = new Date().getMinutes();
    while (dt.getDate() === 1) {
      rc.push({
        header: toLocalTimeString(dt),
        value: dt,
      });
      dt = new Date(dt.getTime());
      dt.setMinutes(dt.getMinutes() + step);
      if (!nd && dt.getHours() >= currentHours && dt.getMinutes() >= currentMinutes) {
        nd = new Date(dt);
      }
    }
    return { items: rc, nextAvailable: nd };
  }, [minuteIntervals]);

  return (
    <Dropdown
      {...dropdownProps}
      items={items}
      defaultValue={nextAvailable ? toLocalTimeString(nextAvailable) : undefined}
      defaultHighlightedIndex={
        nextAvailable
          ? items.findIndex(
              i =>
                i.value.getHours() === nextAvailable.getHours() &&
                i.value.getMinutes() === nextAvailable.getMinutes()
            )
          : undefined
      }
      onChange={(_e, d) => {
        if (d) {
          const value = (d.value as { value: Date }).value;
          const newValue = copyTimeToDate(field.value, value);
          field.onChange(newValue);
        }
      }}
    />
  );
};

export function toLocalTimeString(date: Date): string {
  return moment(date).format("h:mm a");
}
